import { render, staticRenderFns } from "./purchaseRecord.vue?vue&type=template&id=cbc45264&"
import script from "./purchaseRecord.vue?vue&type=script&lang=js&"
export * from "./purchaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./purchaseRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports